import { selectFromVisitDto } from '../../models';

export default selectFromVisitDto()
  .id
  .uuid
  .name
  .phone
  .email
  .load
  .email
  .duration
  .isPriority
  .isScheduling
  .instructions
  .customFields
  .isCompleted
  .isScheduled
  .routificOrderNumber
  .customerOrderNumber
  .deliveryDate
  .customerId
  .customerFilledFields
  .tags(tag => tag.uuid.name)
  .rating(rating => rating.comment.rate)
  .attempts(attempt => attempt
    .orderUuid
    .status
    .reason
    .notes
    .date
    .signature(signature => signature.base64Png.name)
    .photos(photo => photo.url.thumbnail.firebaseStorageUuid)
    .scannedPackages(pkg => pkg.uuid.scannedTime.barcode))
  .scheduledEvent(evnt => evnt
    .route(route => route
      .id
      .name
      .hexColor,
    ))
  .locations(location => location.id.address.originalAddress.latitude.longitude.locationStatusId.active.bestMatch.coordinatesSource)
  .timeWindows(timeWindow => timeWindow.id.startTime.endTime)
  .packages(pkg => pkg.uuid.barcode)
  .toString();
